import { connect } from 'react-redux';
import CreateDM from './';

import { clearError, startDirectMessage } from '../../actions/chatActions';
import { START_DM } from '../../constants/ActionTypes';

const mapStateToProps = state => ({
  createDmError: state.errors[START_DM]
});

const mapDispatchToProps = dispatch => ({
  startDirectMessage: users => dispatch(startDirectMessage(users)),
  clearError: type => dispatch(clearError(type))
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateDM);
